"use client";

import { useLocale } from "next-intl";
import { track } from "@/lib/analytics";
import { EVENEMENT } from "@/lib/evenements";
import { APP_STORE_URL } from "@/lib/config";
import { cn } from "@/lib/utils";

/** Badge « Télécharger sur l'App Store » (lien direct vers la fiche App Store). */
export function AppStoreBadge({
  className,
  compact = false,
}: {
  className?: string;
  /** Variante réduite, pour le pied de page : elle ne doit pas peser
   *  autant qu'un appel à l'action. */
  compact?: boolean;
}) {
  const locale = useLocale();
  const line1 = locale === "en" ? "Download on the" : "Télécharger dans";
  const line2 = "App Store";

  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track(EVENEMENT.APP_STORE_CLIC, { boutique: "apple", emplacement: compact ? "pied" : "page" })}
      aria-label={`${line1} ${line2}`}
      className={cn(
        "inline-flex items-center bg-espresso text-white no-underline transition hover:-translate-y-0.5",
        compact
          ? "gap-2 rounded-[10px] px-3 py-1.5"
          : "gap-2.5 rounded-[13px] px-[18px] py-2.5",
        className,
      )}
    >
      <svg
        width={compact ? 17 : 24}
        height={compact ? 17 : 24}
        viewBox="0 0 24 24"
        fill="#fff"
        aria-hidden
      >
        <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
      </svg>
      <span style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <span
          className={cn(
            "font-medium opacity-80",
            compact ? "text-[8.5px]" : "text-[10.5px]",
          )}
        >
          {line1}
        </span>
        <span
          className={cn(
            "mt-0.5 font-bold tracking-tight",
            compact ? "text-[12.5px]" : "text-[17px]",
          )}
        >
          {line2}
        </span>
      </span>
    </a>
  );
}
